import axios from 'axios';
import axiosUrl from './axios.service';
import store from '../store/index';
const API_URL = axiosUrl.getAxiosUrl();

class ImportsService {
    loadImports() {        
        return axios
            .get(API_URL + `/FilesOverview/fileImports`)
            .then((response) => {
                store.commit('importItems/setImports', response.data);
                store.commit('importItems/togglePageLoadingStatus', false);
            });
    }

    loadStatuses() {
        return axios
            .get(API_URL + `/FilesOverview/fileImportStatuses`)
            .then((response) => {
                store.commit('importItems/setImportStatuses', response.data);                
            });
    }

    filterImports(status) {     
        return axios
            .get(API_URL + `/FilesOverview/fileImportsFiltered?fileStatus=${status}`)
            .then((response) => {
                store.commit('importItems/setImports', response.data);
                store.commit('importItems/togglePageLoadingStatus', false);
            });
    }

    removeImportedFile(fileId) {
        store.commit('importItems/togglePageLoadingStatus', true);
        return axios
            .get(API_URL + `/FilesOverview/deleteImportedFile?fileId=${fileId}`)
            .then((response) => {
                store.commit('importItems/setImports', response.data);
                store.commit('importItems/togglePageLoadingStatus', false);
            });
    }

}

export default new ImportsService();
